/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Modal, Button, ListGroup } from "react-bootstrap";
import {useSelector, useDispatch} from 'react-redux';
import {selectCompany, changeCompanyR} from '../actions/auth.action';
import {useHistory} from 'react-router-dom';

const SelectCompany = ({show, setShow, changeCompany=false}) => {
	const dispatch = useDispatch();
	const handleClose = () => setShow(false);
	const [companies, setCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState({});
	const auth = useSelector(state => state.auth);
	const history = useHistory();
	useEffect(() => {
		let company = JSON.parse(localStorage.getItem("company-s10"));
		if ( company ) setSelectedCompany(company);
		if (auth?.User?.Companies && auth.User.Companies.length > 0) {
			setCompanies(auth.User.Companies);
		} else if ( !auth?.Companies || auth?.Companies.length === 0 ) {
			const userData = JSON.parse(localStorage.getItem('user-s10'));
			if ( userData?.Companies ) setCompanies(userData.Companies );
		} else {
			setCompanies(auth.Companies);
		}
	}, [show]);

	const selectNewCompany = (company) => {
		if (changeCompany && selectedCompany?.Id === company.Id ) {
			return;
		}
		if ( changeCompany ) {
			dispatch(changeCompanyR(company, history))
		} else {
			dispatch(selectCompany(company, history));
		}
	}

	return (
		<>
  
		<Modal show={show} onHide={handleClose}>
		  <Modal.Header closeButton>
			<Modal.Title>Seleccione una empresa</Modal.Title>
		  </Modal.Header>

		  <Modal.Body>
			<ListGroup>
				{
					companies.map(company => {
						return (
							<ListGroup.Item 
								action={!changeCompany || selectedCompany?.Id !== company.Id }
								key={company.Id} 
								onClick={() => selectNewCompany(company)}
							>
								{company.RUC}
								{' - '}
								{company.Name} 
								{(changeCompany && selectedCompany?.Id === company.Id ? " (te encuentras aquí)" : "")}
							</ListGroup.Item>
						)
					})
				}
			</ListGroup>
		  </Modal.Body>

		  <Modal.Footer>
			<Button 
				variant="secondary" 
				onClick={handleClose}
			>
			  Cancelar
			</Button>
		  </Modal.Footer>
		</Modal>
	  </>
	)
}

export default SelectCompany
